
import { route } from 'preact-router';

export default function Pricing() {
  return (
    <div class="page-pricing">
      <h1>料金プラン</h1>
      <p>（準備中）</p>
      <button onClick={() => route('/')}>← トップへ</button>

      <style>{`
        .page-pricing {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: var(--space-lg);
          background: var(--color-bg);
          color: var(--color-text);
        }
        button {
          background: none;
          border: 1px solid var(--color-border);
          border-radius: var(--radius-sm);
          padding: var(--space-xs) var(--space-md);
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}
